var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",class:{ 'footer--with-button': _vm.footerButtonExists }},[(_vm.isIslandHopping)?_c('footer-med-experience'):_c('footer-sail-croatia'),_c('portal-target',{attrs:{"name":"footer-button"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }